import { useI18n, LOCALES, type Locale } from '../i18n';
import { useAuth } from '../lib/auth';

export function Nav() {
  const { t, locale, setLocale, localePath } = useI18n();
  const { status } = useAuth();

  return (
    <nav class="nav">
      <div class="wordmark">
        <b>Beer</b>
        <em>Cup</em>
      </div>
      <div class="nav-links">
        <a href="#about">{t('nav.about')}</a>
        <a href="#partners">{t('nav.partners')}</a>
        <a href="#download">{t('nav.download')}</a>
      </div>
      <div class="nav-right">
        {status === 'signed-in' ? (
          <a class="nav-cta" href={localePath('/play')}>
            {t('header.tabs.play')}
          </a>
        ) : status === 'signed-out' ? (
          <a class="nav-cta" href={localePath('/login')}>
            {t('header.login')}
          </a>
        ) : null}
        <div class="lang" role="group" aria-label="Language">
          {LOCALES.map((l: Locale) => (
            <button
              key={l}
              type="button"
              class={l === locale ? 'active' : ''}
              aria-pressed={l === locale}
              onClick={() => setLocale(l)}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
